import React from 'react'

const EditProduct = () => {
    return (
        <div>
            
        </div>
    )
}

export default EditProduct
